import { GlobalRoutes } from "../../react-router/routes"
import * as UI from "@iyk/ui"
import { Link } from "../../ui/link"

export const FanClipsViewCard = ({ title, images }: { title: string; images: string[] }) => (
  <section className="grid grid-rows-[1fr_auto] rounded border border-white/[10%] bg-white/[3%]">
    <div className="grid grid-cols-[0.65fr_0.35fr] pl-4 pr-3 gap-4 h-[108px]">
      <h3 className="text-sm text-gray-12 self-center">{title}</h3>
      <GridImages images={images} />
    </div>
    <Link
      to={GlobalRoutes.fanClips.feed}
      className="flex items-center justify-center gap-2 text-sm py-3 border-t border-white/[10%]"
    >
      <UI.Icon.Eye /> View the clips
    </Link>
  </section>
)

const GridImages = ({ images }: { images: string[] }) => {
  return (
    <div className="relative w-full grid grid-cols-2 gap-x-1 overflow-hidden">
      <div className="grid grid-rows-2 gap-y-1.5 h-full -translate-y-[4%]">
        <img src={images[0]} className="rounded-md object-cover w-full h-[90px]" />
        <img src={images[1]} className="rounded-md object-cover w-full h-[90px]" />
      </div>
      <div className="grid grid-rows-2 gap-y-1.5 h-full -translate-y-[40%]">
        <img src={images[2]} className="rounded-md object-cover w-full h-[90px]" />
        <img src={images[3]} className="rounded-md object-cover w-full h-[90px]" />
      </div>
    </div>
  )
}
